import { getQSVar, getTotalAddOnsPrice, applyDiscount } from '../utils';
import { IAddOn, IGlassesPackage } from '../types';

export function getPricingDetails(
    selectedPackage: IGlassesPackage,
    addOns: IAddOn[] | undefined
) {
    const framePrice = Number(getQSVar('price')) || 0;
    const addOnsPrice = addOns ? getTotalAddOnsPrice(addOns) : 0;
    const discountPercentage = selectedPackage.discountPercentage ?? 0;
    const glassesPrice = discountPercentage
        ? applyDiscount(selectedPackage.priceInt, discountPercentage)
        : selectedPackage.priceInt;
    const discountedAddOnsPrice = discountPercentage
        ? applyDiscount(addOnsPrice, discountPercentage)
        : addOnsPrice;
    const discount =
        selectedPackage.priceInt -
        glassesPrice +
        (addOnsPrice - discountedAddOnsPrice);
    const subTotal = framePrice + selectedPackage.priceInt + addOnsPrice;
    const total = framePrice + glassesPrice + discountedAddOnsPrice;

    return {
        framePrice,
        glassesPrice,
        discount,
        subTotal,
        total,
    };
}
